import React, { useState, useEffect } from "react";
import { useLocation, Link } from 'react-router-dom';
import { fazerCadastro, fazerLogin, redefinirSenha } from '../api/logincadastro.js';
import Swal from 'sweetalert2'
import { useNavigate } from 'react-router-dom';
import InputMask from 'react-input-mask';

import {
    ContainerConta,
    BoxCadastro,
    P1, P2, P3, P4, P5, P6, P7, P8,
    BoxGoogle,
    InputConta,
    ButtonConta,
    DividerContainer,
    DividerLine,
    DividerText,
    FlexConta,
    InputMascara,
    ContainerInputsConta,
    BoxConta,
    BoxInputs,
    BoxLogin
} from './Account.style.js';
import Google from '../components/svg/google.svg';

import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Loading from '../components/assets/loading.gif';


function CriarConta() {
    const location = useLocation();
    // const [showCadastro, setShowCadastro] = useState(false);

    const [currentView, setCurrentView] = useState("login");

    const [loading, setLoading] = useState(false);


    const navigate = useNavigate();

    // useEffect(() => {
    //     if (location.state?.showLogin) {
    //         setShowCadastro(false);
    //     } else {
    //         setShowCadastro(true);
    //     }
    // }, [location.state]);

    // const handleEntrarClick = () => {
    //     setShowCadastro(false);
    // };

    // const handleCriarContaClick = () => {
    //     setShowCadastro(true);
    // };

    // const handleEsqueciSenhaClick = () => {
    //     setShowCadastro(false);
    // };

    const handleEntrarClick = () => {
        setCurrentView("login");
    };
    
    const handleCriarContaClick = () => {
        setCurrentView("cadastro");
    };
    
    const handleEsqueciSenhaClick = () => {
        setCurrentView("esqueciSenha");
    };

    useEffect(() => {
        verificarLogado()
    }, []);

    const verificarLogado = async () => {

        var get_idusuario = await localStorage.getItem('@idusuario')

        if (get_idusuario != null && get_idusuario != '' ) {
            navigate('/perfil')
            return false
        }

    }

    const clickEntrar = async ()=>{
        var email = document.getElementById("email").value;
        var senha = document.getElementById("senha").value;

        var resposta = await fazerLogin(email, senha);

        if(email == ''){
            toast.error('Email inválido');
            return false
        }

        if(senha == ''){
            toast.error('Senha inválida');
            return false
        }


        if (resposta.erro == "S") {
            Swal.fire({
                title: 'Error!',
                text: resposta.mensagem,
                icon: 'error',
            })

            return false
        }

        //salvar no storage
        var idusuario = ""+resposta.idusuario
        var email = ""+resposta.email
        var token = ""+resposta.token
        var nome = ""+resposta.nome
        var fotoperfil = ""+resposta.fotoperfil

        await localStorage.setItem("@idusuario",idusuario)
        await localStorage.setItem("@email",email)
        await localStorage.setItem("@token",token)
        await localStorage.setItem("@nome",nome)
        await localStorage.setItem("@fotoperfil",fotoperfil)

        Swal.fire({
            title: 'Sucesso',
            text: resposta.mensagem,
            icon: 'success',
        }).then(()=>{
            navigate('/perfil');
        })



    }

    const clickRedefinirSenha = async ()=>{

        var email = document.getElementById("email_redefinir").value

        if(email == "" || !email.includes("@")){
            toast.error('Email inválido');
            return false
        }

        setLoading(true)
        var resposta = await redefinirSenha(email);
        setLoading(false)
        console.log(resposta)


        if(resposta.erro == "S"){
            toast.error(resposta.mensagem);
            return false
        }
        

        Swal.fire({
            title: 'Sucesso',
            text: resposta.mensagem,
            icon: 'success',
        })


     }
    

    function convertDateToISO(date) {
        const [day, month, year] = date.split('/'); // Divide a data pelo caractere '/'
        return `${year}-${month}-${day}`; // Retorna no formato ISO
      }

    const clickCriarConta = async () => {

      
        var nome = document.getElementById("nome").value;
        var email = document.getElementById("email").value;
        var senha = document.getElementById("senha").value;
        var cpf = document.getElementById("cpf").value;
        var data_nascimento = document.getElementById("data_nascimento").value;
        var celular = document.getElementById("celular").value;

       

        if(nome == '' || nome.length < 2){
            toast.error('Nome inválido');
            return false
        }

        if(email == '' || !email.includes("@")){
            toast.error('Email inválido');
            return false
        }

        var senha_forte = isStrongPassword(senha)

        if(senha_forte == false){
            return false
        }

        var cpf_valido  = validateCPF(cpf)

        if(cpf_valido == false){
            toast.error('Esse CPF é inválido!');
            return false;
        }

        var nascimento_valido  = validateBirthDate(data_nascimento)

        if(nascimento_valido == false){
            toast.error('Data de nascimento inválido!');
            return false;
        }

        var telefone_valido  = validateCellPhone(celular)

        if(telefone_valido == false){
            toast.error('Celular inválido!');
            return false;
        }

        data_nascimento = convertDateToISO(data_nascimento);
        
         
        var resposta = await fazerCadastro(nome, email, senha,cpf,data_nascimento,celular);

        if (resposta.erro == "S") {
            Swal.fire({
                title: 'Error!',
                text: resposta.mensagem,
                icon: 'error',
            })

            return false
        }

        Swal.fire({
            title: 'Sucesso',
            text: resposta.mensagem,
            icon: 'success',
        }).then(()=>{
            navigate('/perfil');
        })

        setCurrentView(false);

        



    }


    function validateCellPhone(cellPhone) {
        // Regex para validar o formato (XX) XXXXX-XXXX ou (XX) XXXX-XXXX
        const cellPhoneRegex = /^\(\d{2}\)\s?\d{4,5}-\d{4}$/;
      
        // Verifica se o número atende ao formato esperado
        if (!cellPhoneRegex.test(cellPhone)) {
          return false;
        }
      
        // Valida o DDD (01 a 99, típico para números brasileiros)
        const ddd = parseInt(cellPhone.substring(1, 3), 10);
        if (ddd < 11 || ddd > 99) {
          return false;
        }
      
        return true;
      }
      

    function validateBirthDate(birthDate) {
        // Verifica se a data está no formato DD/MM/AAAA
        const dateRegex = /^\d{2}\/\d{2}\/\d{4}$/;
        if (!dateRegex.test(birthDate)) {
          return false;
        }
      
        // Divide a data em dia, mês e ano
        const [day, month, year] = birthDate.split('/').map(Number);
      
        // Cria um objeto Date para a data fornecida
        const birthDateObj = new Date(year, month - 1, day); // O mês começa do índice 0
      
        // Verifica se a data fornecida é válida
        if (
          birthDateObj.getDate() !== day ||
          birthDateObj.getMonth() !== month - 1 ||
          birthDateObj.getFullYear() !== year
        ) {
          return false;
        }
      
        // Verifica se a data está no futuro
        const today = new Date();
        if (birthDateObj > today) {
          return false;
        }
      
        return true;
      }

    function validateCPF(cpf) {
        // Remove os caracteres de máscara (pontos e hífen)
        const cleanedCPF = cpf.replace(/[.-]/g, '');
      
        // Verifica se o CPF tem 11 dígitos
        if (cleanedCPF.length !== 11) {
          return false;
        }
      
        // Verifica se todos os dígitos são iguais (ex.: 111.111.111-11)
        if (/^(\d)\1+$/.test(cleanedCPF)) {
          return false;
        }
      
        // Função para calcular um dígito verificador
        const calculateDigit = (numbers) => {
          const sum = numbers
            .map((num, index) => num * ((numbers.length + 1) - index))
            .reduce((acc, curr) => acc + curr, 0);
          const remainder = sum % 11;
          return remainder < 2 ? 0 : 11 - remainder;
        };
      
        // Extrai os 9 primeiros números e os dois dígitos verificadores
        const numbers = cleanedCPF.slice(0, 9).split('').map(Number);
        const firstVerifier = parseInt(cleanedCPF[9], 10);
        const secondVerifier = parseInt(cleanedCPF[10], 10);
      
        // Calcula os dígitos verificadores
        const calculatedFirst = calculateDigit(numbers);
        const calculatedSecond = calculateDigit([...numbers, calculatedFirst]);
      
        // Verifica se os dígitos calculados são iguais aos fornecidos
        return calculatedFirst === firstVerifier && calculatedSecond === secondVerifier;
      }


    function isStrongPassword(password) {
        // Critérios para uma senha forte
        const hasUpperCase = /[A-Z]/.test(password); // Pelo menos uma letra maiúscula
        const hasLowerCase = /[a-z]/.test(password); // Pelo menos uma letra minúscula
        const hasNumber = /\d/.test(password); // Pelo menos um número
        const hasMinLength = password.length >= 8; // Mínimo de 8 caracteres
      
        // Verifica se cada critério é atendido e exibe mensagem de erro específica
        if (!hasUpperCase) {
          toast.error('A senha deve conter pelo menos uma letra maiúscula');
          return false;
        }
        if (!hasLowerCase) {
          toast.error('A senha deve conter pelo menos uma letra minúscula');
          return false;
        }
        if (!hasNumber) {
          toast.error('A senha deve conter pelo menos um número');
          return false;
        }
        if (!hasMinLength) {
          toast.error('A senha deve ter no mínimo 8 caracteres');
          return false;
        }
      
        // Se atender a todos os critérios
        return true;
      }



    return (
        <ContainerConta>
            

            {currentView === "cadastro" && (
                <BoxCadastro>
                    {/* Conteúdo da criação de conta */}
                    <BoxConta>
                        <P1>Criar conta</P1>
                    </BoxConta>

                    {/* Removido por lucas ate integrar com a API Google Sign-in */}
                    {/* <BoxGoogle>
                            <img src={Google} alt="Google"/>
                            <P2>Crie a conta com Google</P2>
                        </BoxGoogle>

                        <DividerContainer>
                            <DividerLine/>
                            <DividerText><P7>OU</P7></DividerText>
                        </DividerContainer> */}
                    {/* Removido por lucas ate integrar com a API Google Sign-in */}

                    <ContainerInputsConta>
                        {/* Campos de entrada para cadastro */}

                        <BoxInputs>
                            <P3 style={{ marginBottom: 5 }}>Nome completo</P3>
                            <InputConta type="text" id="nome" />
                        </BoxInputs>

                        <BoxInputs>
                            <P3 style={{ marginBottom: 5 }}>Email</P3>
                            <InputConta type="email" id="email" />
                        </BoxInputs>

                        <BoxInputs>
                            <P3 style={{ marginBottom: 5 }}>Senha</P3>
                            <InputConta type="password" id="senha" />
                        </BoxInputs>

                        <BoxInputs>
                            <P3 style={{ marginBottom: 5 }}>CPF</P3>
                            <InputMascara 
                                mask="999.999.999-99" 
                                maskChar={null} 
                                type="tel" 
                                id="cpf" 
                                placeholder="Digite seu CPF"
                            />
                        </BoxInputs>

                        <BoxInputs>
                            <P3 style={{ marginBottom: 5 }}>Data de Nascimento</P3>
                                <InputMascara 
                                    mask="99/99/9999"
                                    maskChar={null} 
                                    type="tel" 
                                    id="data_nascimento" 
                                    placeholder="Digite sua data de nascimento"
                                />
                        </BoxInputs>

                        <BoxInputs>
                            <P3 style={{ marginBottom: 5 }}>Celular</P3>
                                <InputMascara 
                                    mask="(99) 99999-9999" 
                                    maskChar={null} 
                                    type="tel" 
                                    id="celular" 
                                    placeholder="Digite seu Celular"
                                />
                        </BoxInputs>
                    </ContainerInputsConta>
                    <ButtonConta onClick={() => clickCriarConta()}><P4>Criar conta</P4></ButtonConta>
                    <FlexConta>
                        <P5>Já tem uma conta?</P5>
                        <P6 style={{ cursor: 'pointer' }} onClick={handleEntrarClick}>Entrar</P6>
                    </FlexConta>
                </BoxCadastro>
            )}

            {currentView === "login" && (
                <BoxLogin>
                    {/* Conteúdo para login */}
                    <BoxConta>
                        <P1>Fazer login</P1>
                    </BoxConta>

                    {/* Removido por lucas ate integar com o Google Sign-in */}
                    {/* <BoxGoogle>
                        <img src={Google} alt="Google"/>
                        <P2>Faça login com o Google</P2>
                    </BoxGoogle>

                    <DividerContainer>
                        <DividerLine/>
                        <DividerText><P7>OU</P7></DividerText>
                    </DividerContainer> */}

                    <ContainerInputsConta>
                        {/* Campos de entrada para login */}

                        <BoxInputs>
                            <P3 style={{ marginBottom: 5 }}>Email</P3>
                            <InputConta type="email" id="email" />
                        </BoxInputs>

                        <BoxInputs>
                            <P3 style={{ marginBottom: 5 }}>Senha</P3>
                            <InputConta type="password" id="senha" />
                        </BoxInputs>
                    </ContainerInputsConta>
                    <ButtonConta onClick={() => clickEntrar()}><P4>Entrar</P4></ButtonConta>
                    <FlexConta>
                        <P5>Não tem uma conta?</P5>
                        <P6 style={{ cursor: 'pointer' }} onClick={handleCriarContaClick}>Criar conta</P6>
                    </FlexConta>
                    <FlexConta style={{ marginTop: 10 }}>
                        <P8 onClick={handleEsqueciSenhaClick}>Esqueci minha senha.</P8>
                    </FlexConta>
                </BoxLogin>
            )}

            {currentView === "esqueciSenha" && (
                <BoxLogin>
                    {/* Conteúdo para redefinir senha */}
                    <BoxConta>
                        <P1>Redefinir Senha</P1>
                    </BoxConta>
                    <div style={{marginBottom:20}}>
                        <P5 style={{ textAlign: 'center' }}>
                            Informe o E-mail para o qual <br /> deseja redefinir sua senha
                        </P5>
                    </div>
                    <ContainerInputsConta>
                        <BoxInputs>
                            <P3 style={{ marginBottom: 5 }}>Email</P3>
                            <InputConta type="email" id="email_redefinir" />
                        </BoxInputs>
                    </ContainerInputsConta>
                    {loading == false&&(<ButtonConta onClick={()=>{clickRedefinirSenha()}}><P4>Redefinir Senha</P4></ButtonConta>)}
                    {loading == true&&(<ButtonConta><P4> <img style={{ width: 20, height:20}} src={Loading} /></P4></ButtonConta>)}

                    <FlexConta style={{ marginTop: 10 }}>
                        <P8 onClick={handleEntrarClick}>Voltar para login</P8>
                    </FlexConta>
                </BoxLogin>

                
            )}

            <BoxLogin style={{display:'none'}}>
                {/* Conteúdo para redefinir senha */}
                <BoxConta>
                    <P1>Redefinir Senha</P1>
                </BoxConta>
                <ContainerInputsConta>
                        <BoxInputs>
                            <P3 style={{ marginBottom: 5 }}>Nova Senha</P3>
                            <InputConta type="password" id="senha" />
                        </BoxInputs>

                        <BoxInputs>
                            <P3 style={{ marginBottom: 5 }}>Repita a senha</P3>
                            <InputConta type="password" id="senha" />
                        </BoxInputs>
                </ContainerInputsConta>
                <ButtonConta><P4>Redefinir Senha</P4></ButtonConta>
                <FlexConta style={{ marginTop: 10 }}>
                    <P8 onClick={handleEntrarClick}>Voltar para login</P8>
                </FlexConta>
            </BoxLogin>
            
        </ContainerConta>
    );
}

export default CriarConta;
